// extracted by css-extract-rspack-plugin
var _1 = "nLQaioP1dsamRq0X";
export { _1 as "panel" }
// extracted by css-extract-rspack-plugin
var _1 = "nLQaioP1dsamRq0X";
export { _1 as "panel" }
